import React, { useEffect, useState } from "react";
import axios from '../../utils/axiosInstance';
import {
  FiUsers,
  FiLayers,
  FiRepeat,
  FiThumbsUp,
  FiStar,
  FiSearch,
  FiFilter,
} from "react-icons/fi";
import { FaRupeeSign } from "react-icons/fa";

const DASHBOARD_API = "/admin/api/dashboard";
const CHAPTERS_API = "/admin/api/chapters/all";

function Dashboard() {
  const [dashboard, setDashboard] = useState({
    members: 0,
    chapters: 0,
    c2c: 0,
    reference: 0,
    thankyouSlip: 0,
    thankyouSlipPrice: 0,
    ask: 0,
    testimonial: 0,
  });

  const [activityLists, setActivityLists] = useState({
    c2c: [],
    reference: [],
    thankyouSlip: [],
    ask: [],
    testimonial: [],
  });

  
  const [birthdays, setBirthdays] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [dashboardFilters, setDashboardFilters] = useState({ chapter: "", from: "", to: "" });
  const [dashboardFilterVisible, setDashboardFilterVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  
  const periodOptions = [
    { label: "1 Month", value: "1m" },
    { label: "3 Months", value: "3m" },
    { label: "6 Months", value: "6m" },
    { label: "1 Year", value: "1y" },
    { label: "Lifetime", value: "life" },
    { label: "Custom Range", value: "custom" },
  ];
  const [selectedPeriod, setSelectedPeriod] = useState("life");
  const [activityFilters, setActivityFilters] = useState({ from: "", to: "" });
  const [appliedActivityFilters, setAppliedActivityFilters] = useState({ from: "", to: "" });

  const getPeriodRange = (period) => {
    const today = new Date();
    const toDate = today.toISOString().slice(0, 10);
    if (period === "life") {
      return { from: "", to: toDate };
    }
    if (period === "custom") {
      return { from: activityFilters.from, to: activityFilters.to };
    }
    let months = 0, years = 0;
    if (period === "1m") months = 1;
    else if (period === "3m") months = 3;
    else if (period === "6m") months = 6;
    else if (period === "1y") years = 1;
    const from = new Date(today);
    from.setMonth(from.getMonth() - months);
    from.setFullYear(from.getFullYear() - years);
    const fromDate = from.toISOString().slice(0, 10);
    return { from: fromDate, to: toDate };
  };

  
  useEffect(() => {
    axios.get(CHAPTERS_API)
      .then((res) => {
        const chapterRes = res;
        if (chapterRes.data && Array.isArray(chapterRes.data.chapter)) {
          setChapters(chapterRes.data.chapter.map(ch => ({ value: ch._id || ch.id, label: ch.name })));
          return;
        }
        if (Array.isArray(res.data)) {
          setChapters(res.data.map(c => ({ value: c.id || c._id, label: c.name || c.title || c.label })));
        } else if (res.data && Array.isArray(res.data.data)) {
          setChapters(res.data.data.map(c => ({ value: c.id || c._id, label: c.name || c.title || c.label })));
        }
      })
      .catch(() => {});
  }, []);

 
  const fetchDashboard = (from, to) => {
    setLoading(true);
    const params = new URLSearchParams();
    if (dashboardFilters.chapter) params.append("chapterId", dashboardFilters.chapter);
    if (from) params.append("startDate", from);
    if (to) params.append("endDate", to);
    axios.get(`${DASHBOARD_API}?${params.toString()}`)
      .then(({ data: result }) => {
        if (result.success || result.Status === 1) {
          const d = result.data;
          setDashboard({
            members: d.totalMembers,
            chapters: d.totalChapters,
            c2c: d.totalC2C,
            reference: d.totalReferences,
            thankyouSlip: (d.latest && d.latest.thankYouSlips) ? d.latest.thankYouSlips.length : 0,
            thankyouSlipPrice: d.totalThankYouPrice,
            ask: d.totalAsks,
            testimonial: d.totalTestimonials,
          });
         
          const normalizeItem = (type, item, idx) => {
            const id = idx + 1;
            const date = item.createdAt ? item.createdAt.slice(0, 10) : '';
            if (item.given || item.receiver) {
              const givenName = item.given ? `${item.given.firstName || ''} ${item.given.lastName || ''}`.trim() : '';
              const receiverName = item.receiver ? `${item.receiver.firstName || ''} ${item.receiver.lastName || ''}`.trim() : '';
              let name = givenName ? `Given: ${givenName}` : '';
              if (receiverName) name += ` → Receiver: ${receiverName}`;
              if (!name) name = item.email || item.userId || 'Unknown';
              const profilepic = item.given?.profilepic || item.given?.profilePic || item.receiver?.profilepic || item.receiver?.profilePic || item.profilepic || item.profilePic || '';
              return { id, name, date, profilepic, count: item.count || "" };
            }
            if (typeof item.count !== 'undefined' || item.userId || item.email) {
              const personName = (item.firstName || item.lastName) ? `${item.firstName || ''} ${item.lastName || ''}`.trim() : (item.email || item.userId || 'Unknown');
              const name = personName;
              const profilepic = item.profilepic || item.profilePic || '';
              return { id, name, date, profilepic, count: item.count || "" };
            }
            return { id, name: JSON.stringify(item), date, count: item.count || "" };
          };
          setActivityLists({
            c2c: (d.latest && d.latest.c2c ? d.latest.c2c : []).map((item, idx) => normalizeItem('c2c', item, idx)),
            reference: (d.latest && d.latest.references ? d.latest.references : []).map((item, idx) => normalizeItem('reference', item, idx)),
            thankyouSlip: (d.latest && d.latest.thankYouSlips ? d.latest.thankYouSlips : []).map((item, idx) => normalizeItem('thankyouSlip', item, idx)),
            ask: (d.latest && d.latest.asks ? d.latest.asks : []).map((item, idx) => normalizeItem('ask', item, idx)),
            testimonial: (d.latest && d.latest.testimonials ? d.latest.testimonials : []).map((item, idx) => normalizeItem('testimonial', item, idx)),
          });
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

 
  const fetchBirthdays = () => {
   
    const params = new URLSearchParams();
    params.append('days', '7');
    axios.get(`/api/user/birthdays?${params.toString()}`)
      .then(({ data }) => {
        
        let list = [];
        if (!data) return setBirthdays([]);
       
        const payload = (data.data && (data.data.all || data.data.chapter || data.data.users)) ? data.data : data;
        if (Array.isArray(payload)) {
          list = payload;
        } else if (payload) {
          if (Array.isArray(payload.all)) list = payload.all;
          else if (Array.isArray(payload.chapter)) list = payload.chapter;
          else if (Array.isArray(payload.users)) list = payload.users;
          else if (Array.isArray(payload.data)) list = payload.data;
        }

        const normalized = list.map((u, i) => {
          const name = (u.firstName || u.lastName) ? `${u.firstName || ''} ${u.lastName || ''}`.trim() : (u.name || u.fullName || `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.email || `User ${i+1}`);
          const date = u.dob || u.dobDate || u.birthDate || u.birth_date || u.date || '';
          const profilepic = u.profilepic || u.profilePic || u.avatar || '';
          const daysLeft = (typeof u.daysLeft !== 'undefined') ? u.daysLeft : null;
          const isToday = (typeof u.isToday !== 'undefined') ? u.isToday : null;
          return { id: u.id || u._id || i+1, name, date: date ? date.slice(0,10) : '', profilepic, daysLeft, isToday };
        });
        setBirthdays(normalized);
      })
      .catch(() => setBirthdays([]));
  };

  useEffect(() => {
    const { from, to } = getPeriodRange(selectedPeriod);
    setActivityFilters({ from, to }); setAppliedActivityFilters({ from, to });
    fetchDashboard(from, to);
    
    fetchBirthdays();
    
  }, []);

  const formatFriendlyDate = (isoDate) => {
    if (!isoDate) return '';
    try {
      const d = new Date(isoDate);
      return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
    } catch (e) {
      return isoDate.slice(0,10);
    }
  };

  const daysUntil = (isoDate) => {
    if (!isoDate) return '';
    try {
      const today = new Date();
      const d = new Date(isoDate);
      // Use month/day from source, apply to current year
      const thisYear = new Date(today.getFullYear(), d.getMonth(), d.getDate());
      let diff = Math.ceil((thisYear - today) / (1000 * 60 * 60 * 24));
      if (diff < 0) {
        const nextYear = new Date(today.getFullYear() + 1, d.getMonth(), d.getDate());
        diff = Math.ceil((nextYear - today) / (1000 * 60 * 60 * 24));
      }
      return diff;
    } catch (e) {
      return '';
    }
  };

  const sortedBirthdays = birthdays.slice().sort((a, b) => {
    const da = daysUntil(a.date) || 9999;
    const db = daysUntil(b.date) || 9999;
    return da - db;
  });

  const handleDashboardFilterChange = (e) => {
    const { name, value } = e.target;
    setDashboardFilters(prev => ({ ...prev, [name]: value }));
  };

  const handlePeriodChange = (e) => {
    const period = e.target.value;
    setSelectedPeriod(period);

    const { from, to } = getPeriodRange(period);
    setActivityFilters({ from, to });
    setAppliedActivityFilters({ from, to });

    fetchDashboard(from, to);
  };

  const handleCustomDateChange = (field, value) => {
    setActivityFilters(prev => ({ ...prev, [field]: value }));
  };

  const applyCustomActivityRange = () => {
    setAppliedActivityFilters({ ...activityFilters });
    fetchDashboard(activityFilters.from, activityFilters.to);
  };

  // Apply all dashboard filters (chapter + period/custom range)
  const applyFilters = () => {
    let { from, to } = getPeriodRange(selectedPeriod);
    if (selectedPeriod === 'custom') {
      from = activityFilters.from;
      to = activityFilters.to;
    }
    setAppliedActivityFilters({ from: from || '', to: to || '' });
    fetchDashboard(from, to);
  };

  // Clear all dashboard filters
  const clearAllFilters = () => {
    setDashboardFilters({ chapter: '' });
    setSelectedPeriod('life');
    setActivityFilters({ from: '', to: '' });
    setAppliedActivityFilters({ from: '', to: '' });
    fetchDashboard('', '');
  };

  // Activities filter logic for tables  
  const getFilteredActivities = (items) => {
    let arr = items || [];
    const { from, to } = appliedActivityFilters;
    // If no date filters applied, return items as-is
    if (!from && !to) return arr;
    return arr.filter(item => {
      const itemDate = item.date;
      // If the item has no date, include it (can't be reliably filtered)
      if (!itemDate) return true;
      let ok = true;
      if (from) ok = ok && (itemDate >= from);
      if (to) ok = ok && (itemDate <= to);
      return ok;
    });
  };

  const CARDS = [
    { key: "members", title: "Members", value: dashboard.members, icon: <FiUsers size={28} /> },
    { key: "chapters", title: "Chapters", value: dashboard.chapters, icon: <FiLayers size={28} /> },
    { key: "c2c", title: "V2V", value: dashboard.c2c, icon: <FiRepeat size={22} /> },
    { key: "reference", title: "References", value: dashboard.reference, icon: <FiSearch size={22} /> },
    {
      key: "thankyouSlip",
      title: "Thankyou Slips",
      value: dashboard.thankyouSlipPrice,
      extra: (
        <>
          <FaRupeeSign size={18} style={{ marginRight: '5px' }}/>
          {dashboard.thankyouSlipPrice}
        </>
      ),
      icon: <FaRupeeSign size={22} />,
    },
    { key: "ask", title: "Ask", value: dashboard.ask, icon: <FiThumbsUp size={22} /> },
    { key: "testimonial", title: "Testimonials", value: dashboard.testimonial, icon: <FiStar size={22} /> },
  ];

  const activityOptions = [
    { key: "c2c", label: "V2V" },
    { key: "reference", label: "References" },
    { key: "thankyouSlip", label: "Thankyou Slips" },
    { key: "ask", label: "Ask" },
    { key: "testimonial", label: "Testimonials" },
  ];

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Dashboard Overview</h2>
      {/* Dashboard filter toggle */}
      <div className="text-end mb-2">
        <button
          onClick={() => setDashboardFilterVisible(v => !v)}
          className="btn btn-sm btn-success px-2 me-2"
        >
          <FiFilter className="me-1" />
        </button>
      </div>
      {/* Dashboard filter section */}
      {dashboardFilterVisible && (
        <div className="overflow-hidden" style={{ maxHeight: "500px", transition: "max-height 0.4s ease" }}>
          <div className="p-3 mb-4 rounded-3 shadow-sm bg-white">
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="small fw-semibold">Chapter</label>
                <select
                  name="chapter"
                  className="form-select rounded-pill"
                  value={dashboardFilters.chapter}
                  onChange={handleDashboardFilterChange}
                >
                  <option value="">All Chapters</option>
                  {chapters.map((c) => (
                    <option key={c.value} value={c.value}>{c.label}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="small fw-semibold">Activity Period</label>
                <select
                  className="form-select rounded-pill"
                  value={selectedPeriod}
                  onChange={handlePeriodChange}
                >
                  {periodOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-2 d-flex align-items-end gap-2">
                <button
                  className="btn btn-success rounded-pill"
                  onClick={applyFilters}
                  disabled={selectedPeriod === 'custom' && (!activityFilters.from || !activityFilters.to)}
                >
                  Apply
                </button>
                <button
                  className="btn btn-outline-secondary rounded-pill"
                  onClick={clearAllFilters}
                >
                  Clear
                </button>
              </div>
              {selectedPeriod === "custom" && (
                <>
                  <div className="col-md-2">
                    <label className="small fw-semibold">From Date</label>
                    <input
                      type="date"
                      className="form-control rounded-pill"
                      name="from"
                      value={activityFilters.from}
                      onChange={e => handleCustomDateChange("from", e.target.value)}
                      max={activityFilters.to || undefined}
                    />
                  </div>
                  <div className="col-md-2">
                    <label className="small fw-semibold">To Date</label>
                    <input
                      type="date"
                      className="form-control rounded-pill"
                      name="to"
                      value={activityFilters.to}
                      onChange={e => handleCustomDateChange("to", e.target.value)}
                      min={activityFilters.from || undefined}
                      max={new Date().toISOString().slice(0, 10)}
                    />
                  </div>
                  <div className="col-md-2 d-flex align-items-end gap-2">
                    <button
                      className="btn btn-success rounded-pill"
                      onClick={applyFilters}
                      disabled={selectedPeriod === 'custom' && (!activityFilters.from || !activityFilters.to)}
                    >
                      Apply
                    </button>
                    <button
                      className="btn btn-outline-secondary rounded-pill"
                      onClick={clearAllFilters}
                    >
                      Clear
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Members + Chapters row */}
      <div className="row g-4 mb-4">
        {[CARDS[0], CARDS[1]].map((card, i) => (
          <div className="col-md-6" key={i}>
            <div className="p-4 rounded-4 shadow-sm layout-2">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="fw-semibold text-secondary">{card.title}</h6>
                  <h2 className="fw-bold mt-2">{card.value}</h2>
                </div>
                <div className="text-dark opacity-75">{card.icon}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Subtitle */}
      <h5 className="fw-bold text-secondary mb-3">Activities</h5>
      {/* Activity summary cards */}
      <div className="row g-2 mb-4">
        {activityOptions.map((act) => {
          const card = CARDS.find(c => c.key === act.key) || { title: act.label || '', value: '', icon: null };
          return (
            <div className="col-12 col-md-2" key={act.key}>
              <div className="activity-card-small p-2 rounded-4 shadow-sm layout-2 mb-2" style={{ cursor: "pointer", minHeight: "80px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="d-flex flex-column justify-content-center align-items-center w-100">
                  <div className="text-secondary" style={{ fontSize: "14px" }}>{card.title}</div>
                  <div className="fw-bold mt-1" style={{ fontSize: "22px" }}>{card.value}</div>
                  <div className="text-dark opacity-75 mt-1">{card.icon}</div>
                </div>
              </div>
            </div>
          );
        })}
        
      </div>
      {/* Upcoming birthdays table */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card shadow-sm">
            <div className="card-header bg-white d-flex align-items-center justify-content-between">
              <div>
                <h6 className="mb-0">Upcoming Birthdays</h6>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: '70px' }}>Sr No.</th>
                      <th style={{ width: '60px' }}>Avatar</th>
                      <th style={{ width: '140px' }}>Name</th>
                      <th style={{ width: '140px' }}>Birthday</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedBirthdays.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-center text-muted">No upcoming birthdays found.</td>
                      </tr>
                    )}
                    {sortedBirthdays.map((b, i) => (
                      <tr key={b.id}>
                        <td>{i + 1}</td>
                        <td>
                          {b.profilepic ? (
                            <img src={b.profilepic} alt="avatar" style={{ width:36, height:36, borderRadius: '50%', objectFit: 'cover' }} />
                          ) : (
                            <div className="activity-avatar activity-initial" style={{ width:36, height:36, display:'inline-flex', alignItems:'center', justifyContent:'center' }}>{(b.name||'').charAt(0).toUpperCase()}</div>
                          )}
                        </td>
                        <td>{b.name}</td>
                        <td>{formatFriendlyDate(b.date)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        {activityOptions.map((act, idx) => (
          <div className="col-lg-4 mb-4" key={act.key}>
            <div className="card shadow-sm card-sm">
              <div className="card-header bg-white pb-0 d-flex align-items-center justify-content-between">
                <span className="fw-semibold">{act.label} List</span>
              </div>
              <div className="card-body pt-2">
                <div className="table-responsive">
                  <table className="table table-sm table-bordered align-middle mb-0">
                    <thead>
                      <tr className="bg-light">
                        <th style={{ width: "60px" }}>Sr No.</th>
                        <th>Activity Name</th>
                        <th>Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getFilteredActivities(activityLists[act.key])?.length === 0 && (
                        <tr>
                          <td colSpan="3" className="text-center text-muted">No activities found.</td>
                        </tr>
                      )}
                      {getFilteredActivities(activityLists[act.key]).map(item => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                              {item.profilepic ? (
                                <img src={item.profilepic} alt="avatar" className="activity-avatar" />
                              ) : (
                                <div className="activity-avatar activity-initial">{(item.name || '').charAt(0).toUpperCase()}</div>
                              )}
                              <div>{item.name}</div>
                            </div>
                          </td>
                          <td>{item.count || ""}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <style>
        {`
        .activity-card-small {
          min-height: 80px !important;
          padding: 6px 0 !important;
        }
        .layout-2 {
          background: linear-gradient(135deg,#ffffff, #f1f1f1);
          border-left: 5px solid #F94F01;
          transition: 0.3s;
        }
        .activity-card-small:hover {
          transform: scale(1.04);
          box-shadow: 0 4px 12px rgba(0,0,0,0.10);
        }
        .layout-2:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
        }
        .card-sm .card-body {
          padding-top: 0.5rem !important;
          padding-bottom: 0.5rem !important;
          padding-left: 0.75rem !important;
          padding-right: 0.75rem !important;
        }
        .card-sm .card-header {
          padding: 0.5rem 0.75rem !important;
          font-size: 0.95rem;
        }
        .table.table-sm th, .table.table-sm td {
          padding: 0.35rem 0.5rem;
        }
        .table.table-sm {
          font-size: 0.87rem;
        }
        .activity-avatar {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          object-fit: cover;
          background: #e9ecef;
          display: inline-block;
        }
        .activity-initial {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #495057;
          font-weight: 600;
        }
        `}
      </style>
    </div>
  );
}

export default Dashboard;